import { NgModule } from '@angular/core';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { CommonModule} from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { DatePipe} from './datePipe';
import { NamePipe } from './namePipe';
import { TagPipe } from './tagPipe';
import {TypePipe} from './typePipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [DatePipe,NamePipe,TagPipe,TypePipe],
  providers: [],
  exports: [DatePipe,NamePipe,TagPipe,TypePipe]
})

export class SearchCriteriaModule {

}
